import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает просмотренные объявления
 */
export const selectOffersFromHistory = ({ recommendedOffers: { offersFromHistory } }: IApplicationState) =>
  offersFromHistory.items;
